import React from "react";

export const Name = ({ name }) => {
    return (
        <>{name}</>
    )
}